import React from 'react';
import Tracking from '../../utils/tabs/tracking/Tracking';

/**
 * Affiche le composant de suivi du colis dans le drawer
 * de la section Réception
 */
const TrackingTab = () => (
  <div>
    <Tracking />
  </div>
);

export default TrackingTab;
